import React from 'react';

const DataColumns = ({
  onEditItem,
  deleteFlowStepDialog,
}) => {
  return [
    {
      title: 'Actions',
      width: '20px',
      cell: (props) => (
        <td>
          <div className='k-justify-content-center'>
            <span
              className='indicator-icon sis-ico-edit-1 !k-font-size-lg !k-mx-1'
              title='Edit'
              onClick={() => onEditItem(props.dataItem)}
              style={{ cursor: 'pointer', color: '#000' }}
            ></span>
            <span
              className='indicator-icon sis-ico-bin-2 !k-font-size-lg'
              title='Delete'
              onClick={() => deleteFlowStepDialog(props.dataItem)}
              style={{ cursor: 'pointer', color: '#f44336' }}
            ></span>
          </div>
        </td>
      ),
    },
    {
      field: 'DisplayName',
      title: 'Display Name',
      width: '250px',
    },
    {
      field: 'Value',
      title: 'Value',
      width: '200px',
    },
    {
      field: 'Type',
      title: 'Type',
      width: '200px',
    },
  ];
};

export default DataColumns;
